import React from "react";

export default function HeroSection() {
  return (
    <section className="bg-[#002342] relative min-h-[350px] sm:min-h-[400px] md:min-h-[500px] lg:min-h-[557px] flex items-center justify-center px-4 sm:px-6 md:px-8 py-12 sm:py-16">
      <div className="w-full max-w-[320px] sm:max-w-[480px] md:max-w-[680px] lg:max-w-[880px] text-center text-white">
        {/* Main Title with Symbol */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 md:gap-[16px] mb-4 sm:mb-6 md:mb-[20px]">
          <h1 className="font-bauhaus font-black text-2xl sm:text-3xl md:text-5xl lg:text-[72px] leading-tight sm:leading-tight md:leading-tight lg:leading-[86px] tracking-[-2%] sm:tracking-[-3%] md:tracking-[-4%]">
            magikk
          </h1>
          <div className="w-[50px] h-[14px] sm:w-[65px] sm:h-[18px] md:w-[100px] md:h-[28px] lg:w-[151px] lg:h-[43px] relative flex-shrink-0">
            <img
              src="/assets/landing-2025/hero-logo-symbol.svg"
              alt="Magikk Hero Symbol"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        {/* Subtitle */}
        <h2 className="font-bauhaus font-medium text-xl sm:text-2xl md:text-4xl lg:text-[66px] leading-tight sm:leading-tight md:leading-tight lg:leading-[86px] tracking-[-2%] sm:tracking-[-3%] md:tracking-[-4%] lg:tracking-[-4.36%] mb-4 sm:mb-6 md:mb-[20px] px-2">
          social tech de impacto
        </h2>

        {/* Description */}
        <div className="max-w-[280px] sm:max-w-[400px] md:max-w-[600px] lg:max-w-[724px] mx-auto">
          <p className="font-raleway font-normal text-xs sm:text-sm md:text-base leading-relaxed lg:leading-[24px] px-2 sm:px-4">
            <span className="font-semibold">Transformamos ações sociais em ativos de negócio:</span> produtos solidários, experiências de impacto,
            projetos incentivados e tecnologia para conectar marcas a causas com rastreabilidade, gamificação e resultado.
          </p>
        </div>
      </div>
    </section>
  );
}
